<ion-buttons>
  <ion-button (click)="clearSignaturePad()" fill="clear">
    <ion-icon name="refresh-outline" slot="icon-only"></ion-icon>
  </ion-button>
</ion-buttons>
<signature-pad [options]="signaturePadOptions"></signature-pad>
